import { useEffect, useState } from 'react';

import { useSessionData } from '@confluence/session-data';

import { WhiteboardOrgDataService } from './services/whiteboard-org-data-service';

export const useOrgDataService = () => {
	const [orgDataService] = useState(() => new WhiteboardOrgDataService());

	const { orgId } = useSessionData();

	useEffect(() => {
		if (orgId) {
			orgDataService.updateOrgId(orgId);
		}
	}, [orgDataService, orgId]);

	return orgDataService;
};
